module.exports = __webpack_public_path__ + "img/join-int.3c28dc72.svg";